export default "__VITE_ASSET__Bs$QW0sN__"